/**
 * External Dependencies
 */
import $ from 'jquery'
import slick from 'slick-carousel'

$(() => {

      // site galleries

      $('.slick').slick({
        rows: 0,
        dots: true,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        customPaging : function(slider, i) {
           return '<span> &#x2022; </span>';
         },
      });

      $('.elementi').slick({
        rows: 0,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
          responsive: [
            {
              breakpoint: 640,
              settings: {
                slidesToShow: 1,
                variableWidth:true,
                arrows: false,
              }
            }
          ]

      });



      const $abb = $('.abbonamento-pagina .elementi article');

      $abb.on('click', function (e) {
        $abb.removeClass('active');
        $(this).addClass('active');
      });


      $('.categoria-pagina').each(function (index, sliderWrap) {
        var $slider = $(sliderWrap).find('.vehicles-gall.vehicle_categories');
        var $prev = $(sliderWrap).find('.slick-prev');
        var $next = $(sliderWrap).find('.slick-next');
        $slider.slick({
          slidesToShow: 5,
          slideToScroll: 1,
          rows: 0,
          speed: 300,
          arrows: true,
          infinite: false,
          centerMode: false,
          nextArrow: $next,
          prevArrow: $prev,
          variableWidth:true,

          responsive: [
            {
              breakpoint: 640,
              settings: {
                slidesToShow: 1,
                variableWidth:true,
                infinite: true,
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                variableWidth:true,
              }
            }
          ]
        });
    });

    $('.categoria-pagina').each(function (index, sliderWrap) {
      var $slider = $(sliderWrap).find('.vehicles-gall.vehicle_usage');
      var $prev = $(sliderWrap).find('.slick-prev');
      var $next = $(sliderWrap).find('.slick-next');
      $slider.slick({
        slidesToShow: 4,
        slideToScroll: 1,
        rows: 0,
        speed: 300,
        arrows: true,
        infinite: false,
        centerMode: false,
        nextArrow: $next,
        prevArrow: $prev,
        swipe : true,
        draggable : true,
        responsive: [
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
              variableWidth:true,
              infinite: true,
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              variableWidth:true,
            }
          }
        ]
      });
  });
  //  Add label to input CF7

  const $inputclk = $('.click-input');

  $inputclk.on('click', function (e) {
      var next=$(this).next();
      var file=next.next().find('input').attr('id');

      $('#'+file).on('change', function () {
          var $path = $('#'+file)[0].files[0]['name'];
          next.html($path);
      });



  });

      // Add ids to checkbox CF7

      const $radioid=$('.makes-form .radio');
      const $makesradio=$('.makes-form .radio');
      const $inputradio=$('input[name=makes]');

     $radioid.on('click', function(e) {
      var $make = $(this).data('value');
      $makesradio.removeClass('active');
      $(this).addClass('active');
      $inputradio.val($make);

    });

    //floating label

  $(".wpcf7 .wpcf7-form-control")
  .on("focus", function () {
    $(this).parents("label").addClass("floating-label-active");
  })
  .on("blur", function () {
    if( $(this).val().length === 0 ) {
    $(this).parents("label").removeClass("floating-label-active");
    }
  });

  // inside search
  $("input.inside-search").on("keyup", function () {
    var $target=$(this).data('search');
  var $filter = $(this).val().toUpperCase();
  //Show all div class target
    $("#"+$target+' li').show();
  //All div class target that not contains filter will be hidden
    $("#"+$target+' li').each(function(index, elem){
  if($(elem).text().toUpperCase().includes($filter)) { //Not hidden
  } else { $(elem).hide(); }
    });
  });

    // filter in page

    let $article = $('.utilizzo-pagina .vehicles');
    let $filtro = $('#fil-inside .fil-in');

    $filtro.on('click', function(e) {
      e.preventDefault();
      jQuery(this).toggleClass('active');
      jQuery(this).siblings().removeClass('active');
      let filter = $(this).data('filter');

      if(filter==='*'){
        $article.find('article').addClass('active');
    }else{
      $article.find('article').removeClass('active');
      $article.find('.filinside-' + filter).addClass('active');
      }

    })

  // bottoni che aprono un target

  const $btnop=$('.open-button');
  const $modulo=$('.modulo-popup');
  const $btnoleggia=$('.btn-noleggia');

  $btnop.on('click', function(e) {
    e.stopPropagation();
      // spostamento Hero Home
      if($(this).is('#home-search')){
        $('html, body').animate({
          scrollTop: $('#home-search').offset().top -130
      }, 500);
      $('body').css('overflow','hidden');

      }

    $modulo.removeClass('open');
      $btnoleggia.toggle();

      let $target = $(this).data('target');
      let $title = $(this).data('title');
      $(this).toggleClass('open');
      if($title){
        $('form input[name=veicolo]').val($title)
      }
    if($(this).attr('id')=='top-button') {
      $('body').toggleClass('open-'+ $target);
      $('#' + $target).toggleClass('open');
      $('#mega-menu .anicircle, header#top .anicircle:not(".featured-post-circle")').addClass('entered');
      if($('#' + $target).hasClass('open')){
        $('body').css('overflow','hidden');
      } else {
        $('body').css('overflow','visible');
      }
    } else if($(this).hasClass('chiudi')) {
      $('body').removeClass('open').css('overflow','visible');
      $('#' + $target).removeClass('open');

    } else if($(this).hasClass('chiudi-noleggio')) {
      $('#' + $target).removeClass('open');

    }

    else if($('#' + $target).hasClass('modulo-popup') || $('#' + $target).hasClass('panel-slide') ) {
      $('body').addClass('open').css('overflow','hidden');
      $('#' + $target).addClass('open');


    } else {
      $('#' + $target).addClass('open');
      $('body').addClass('open-mobile');
    }


     /* click outside to close modules*/
var elClick = document.querySelector('#search-home .tabs');
document.body.addEventListener('click', function (event) {
    if (!elClick.contains(event.target)) {
      $('#search-home.open').removeClass('open');
      $('body.open').removeClass('open');
      $('body').css('overflow','visible');

    }
});

  });


  // Accordion
  $( ".accordion section" ).each(function( index ) {
    var height=$(this).data('height');
    if($( this ).height()+'px' < height ) {
      $( this).find('.btn-accordion').addClass('hidden');
    }
  });

  const $btnacc=$('.accordion .btn-accordion');

  $btnacc.on('click', function(e) {
    let $height='';
    $height=$(this).data('height');

    $(this).toggleClass('collapsed');
    let $panel=$(this).data('target');


    var divSide = $('#'+$panel+' .content').height();

    if($(this).hasClass('collapsed')){
      $('#'+$panel).addClass('collapsed').animate( {maxHeight: $height }, { queue:false, duration:500 });
    }else {
      $('#'+$panel).removeClass('collapsed').animate( {maxHeight: divSide+'px' }, { queue:false, duration:500 });

    }

  });


  // Tab buttons
  const $btntabs=$('.tabs .open-tab');
  const $slicktarget=$('.vehicles-gall');

  $btntabs.on('click', function(e) {
    if( $(window).width() < 1024 ){
      let $slide= $(this).data('slick-index');
      $slicktarget.slick('slickGoTo', $slide);
    }
    let $target = $(this).data('target');
    $(this).toggleClass('active');
    $(this).siblings().removeClass('active active-desktop');
    $('#' + $target).toggleClass('open');
    $('#' + $target).siblings().removeClass('open open-desktop');
    $('body').toggleClass('open-mobile');

  });


// thank you tab cf7
document.addEventListener(
  "wpcf7mailsent",
  function (event) {
      //place your contact form id number
      $('.no-sent').removeClass('open');
      $('.sent').addClass('open');
  },
  false
);

// Smoth scroll for anchors

$('a[href^="#"]').on('click', function(e) {
  $('html, body').animate({
      scrollTop: $('[id="' + $.attr(this, 'href').substr(1) + '"]').offset().top -100
  }, 500);

  return false;
});
})




$(document.body).on('touchmove', onScroll); // for mobile
$(window).on('scroll', onScroll);

$.fn.isOnScreen = function(){

  var win = $(window);

  var viewport = {
      top : win.scrollTop(),
      left : win.scrollLeft()
  };
  viewport.right = viewport.left + win.width();
  viewport.bottom = viewport.top + win.height();

  var bounds = this.offset();
  bounds.right = bounds.left + this.outerWidth();
  bounds.bottom = bounds.top + this.outerHeight();

  return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

};

$('.heropage-pagina .anicircle:not(".featured-post-circle")').each(function() {
  $(this).addClass('entered', $(this).isOnScreen());
});

// callback
function onScroll(){
  if($(window).scrollTop() > 50) {
    $("#top").addClass("active");
  } else {
    $("#top").removeClass("active");
  }

  var scrollPos = $(document).scrollTop();
  let windowBottom = $(this).scrollTop() + $(this).height() -200;
  let windowTop = $(this).scrollTop();


  const $numeri = $(".anicircle:not('.featured-post-circle')");
  if($numeri.length){

    $($numeri).each(function() {
      $(this).toggleClass('entered', $(this).isOnScreen());
    });


}


}


//open filter based on vehicle-category
$( window ).on( "load", function() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const tab = urlParams.get('tab');

  if (tab) {
    const $btntabs = $('.tabs .open-tab' + `[data-target='tab-${tab}']`);
    $btntabs.toggleClass('active');
    const $tab = $('#tab-' + tab);
    $tab.addClass('open');
    $tab.siblings().removeClass('open, open-desktop');
    $('body').toggleClass('open-mobile');
  }
} );
